import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
const replacementTable = {
    '/': '--_',
    ' ': '__',
    '.': '--',
};
const keyValueAssignmentOperator = '_-_';
const keyValueSeparator = '-_-';
const CalendarLinkTrackingParams = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid'];
export class CalendarLinkListener extends Listener {
    constructor() {
        super();
        const calendarLinks = document.querySelectorAll('[href^="https://outlook.office365.com"]');
        if (calendarLinks.length === 0) {
            return;
        }
        const trackingHandler = TrackingHandler.getInstance();
        if (trackingHandler.isInternalTest) {
            return;
        }
        trackingHandler.initialized.then(() => {
            if (trackingHandler.source === 'undefined' &&
                trackingHandler.medium === 'undefined' &&
                trackingHandler.campaign === 'undefined') {
                return;
            }
            let trackingParamValues = {
                src: trackingHandler.source,
                md: trackingHandler.medium,
                cp: trackingHandler.campaign,
            };
            const url = new URL(window.location.href);
            for (const param of CalendarLinkTrackingParams) {
                if (url.searchParams.has(param)) {
                    trackingParamValues[param] = url.searchParams.get(param);
                }
            }
            trackingParamValues.vtuid = trackingHandler.visitorId;
            trackingParamValues.vuid = trackingHandler.viewId;
            trackingParamValues.url = url.hostname + url.pathname;
            let trackingParamString = '';
            Object.entries(trackingParamValues).forEach(([key, value]) => (trackingParamString +=
                key + keyValueAssignmentOperator + this.replaceValues(value) + keyValueSeparator));
            trackingParamString = trackingParamString.slice(0, -1);
            calendarLinks.forEach((link) => {
                let linkUrl = new URL(link.getAttribute('href'));
                linkUrl.searchParams.set('RefID', trackingParamString);
                link.setAttribute('href', linkUrl.toString());
            });
        });
    }
    replaceValues(str) {
        return Object.entries(replacementTable).reduce((acc, [key, value]) => acc.replaceAll(key, value), str);
    }
}
